import { FC, memo } from "react"
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface PasswordInputProps {
    label: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    placeholder?: string
    required?: boolean
    autoComplete?: string
    helperText?: string
}

const PasswordInput: FC<PasswordInputProps> = ({ label, value, onChange, placeholder = '', required = false, autoComplete = ``, helperText }) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <input
                type="password"
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                autoComplete={autoComplete}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
            />
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(PasswordInput)

